import React from "react";
import Link from "next/link";
import Image from "next/image";
import "./MenuOverlay.styles.scss";
import { usePathname } from "next/navigation";

const MenuOverlay = ({ isMenuOpen = false, toggleMenu }) => {
  const pathName = usePathname();
  const MenuItemList = [
    {
      label: "Home",
      icon: "https://assets.turnoclub.com/developer/innovolt/icons/home-svgrepo-com 1.svg",
      darkIcon:
        "https://assets.turnoclub.com/developer/innovolt/icons/home-dark-icon.svg",
      link: "/",
    },
    // {
    //   label: "Vehicles",
    //   icon: "https://assets.turnoclub.com/developer/innovolt/icons/truck-white-icon.svg",
    //   darkIcon:
    //     "https://assets.turnoclub.com/developer/innovolt/icons/truck-icons.svg",
    //   link: "/category/all-products",
    // },
    // {
    //   label: "Blog",
    //   icon: "https://assets.turnoclub.com/developer/innovolt/icons/blog-icon.svg",
    //   darkIcon:
    //     "https://assets.turnoclub.com/developer/innovolt/icons/blog-dark-icon.svg",
    //   link: "/blogs",
    // },
  ];
  return (
    <div className="menu-parent-container">
      <div className={`overlay ${isMenuOpen ? "open" : ""}`}>
        <div className="closeIcon" onClick={toggleMenu}>
          &#10005;
        </div>
        <nav className="menu">
          <div className="megaMenuOpenIcon">
            <Link href={"/"}>
              <Image
                src="https://assets.turnoclub.com/developer/offer-turno-images/S3/innovolt/logo.svg"
                alt="innovolt"
                width={100}
                height={60}
              />
            </Link>
          </div>
          <ul className="menu-boxes">
            {MenuItemList?.map((menuItem, index) => (
              <Link href={menuItem?.link} key={menuItem.label}>
                <li
                  className={`menu-item-container${
                    pathName === menuItem.link ? "_isActive" : ""
                  }`}
                  role="button"
                  onClick={toggleMenu}
                >
                  <div className="menu-item-label">{menuItem.label}</div>
                  <Image
                    src={
                      pathName === menuItem.link
                        ? menuItem.icon
                        : menuItem.darkIcon
                    }
                    alt={menuItem.label}
                    width={30}
                    height={30}
                    className={`menu-icon`}
                  />
                </li>
              </Link>
            ))}
          </ul>
          <div className="menu-item-contact-container">
            <div className="phone-icon-container">
              <Image
                src="https://assets.turnoclub.com/developer/innovolt/icons/call-icon.svg"
                alt="call-icon"
                width={24}
                height={24}
              />
            </div>
            <div className="menu-item-contact">
              <div className="menu-item-contact-label">Need help?</div>
              <div className="menu-item-contact-number">
                Call us at{" "}
                <Link
                  href={`tel:8970233233`}
                  className="call_link"
                  target="_blank"
                >
                  8970233233
                </Link>
              </div>
            </div>
            <div className="menu-item-right-arrow-icon">
              <Image
                src={
                  "https://assets.turnoclub.com/developer/innovolt/icons/right-arrow-icon.svg"
                }
                alt="right-arrow"
                width={24}
                height={24}
              />
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default MenuOverlay;
